import { handleChunkLoadError } from '@hydra/utils/handleChunkLoadError';

export default ({
  path: 'performance/:url',
  async getComponent () {
    const {
      default: CoreWebVitalsContainer
    } = await import(/* webpackChunkName: "performance-container" */ './containers/CoreWebVitalsContainer')
      .catch(handleChunkLoadError);
    return CoreWebVitalsContainer;
  },
  getData ({ context }) {
    return context.props;
  }
});
